import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { exitPreview, previewLabel } from '../utils/preview';
import './PreviewBanner.css';

// Shown on every screen while a developer is previewing as a made-up account
export default function PreviewBanner() {
  const { user } = useAuth();
  if (!user?.isPreview) return null;
  const label = previewLabel();
  return (
    <div className="preview-banner" role="status">
      <span>
        Preview{label ? `: ${label}` : ''}. This is a made-up account, so nothing can be changed.
      </span>
      <button type="button" className="preview-banner__exit" onClick={() => exitPreview()}>
        Back to my account
      </button>
    </div>
  );
}
